module.exports = __webpack_public_path__ + "img/small.6b581045.jpg";